var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.026 2.26999C13.2409 2.19844 13.4693 2.1765 13.6939 2.20583C13.9185 2.23515 14.1336 2.31496 14.323 2.43928C14.5123 2.5636 14.6711 2.7292 14.7873 2.92364C14.9035 3.11808 14.9742 3.33633 14.994 3.56199L15 3.69399V9.17999L18.794 9.93998C19.1102 10.003 19.3976 10.1662 19.6138 10.4054C19.8299 10.6446 19.9632 10.9471 19.994 11.268L20 11.41V19H21C21.2549 19.0003 21.5 19.0979 21.6854 19.2728C21.8707 19.4478 21.9822 19.6869 21.9972 19.9414C22.0121 20.1958 21.9293 20.4464 21.7657 20.6418C21.6021 20.8373 21.3701 20.9629 21.117 20.993L21 21H3C2.74512 20.9997 2.49997 20.9021 2.31463 20.7271C2.12929 20.5522 2.01776 20.313 2.00283 20.0586C1.98789 19.8041 2.07067 19.5536 2.23426 19.3582C2.39785 19.1627 2.6299 19.0371 2.883 19.007L3 19H4V6.35999C4 5.75999 4.356 5.22399 4.898 4.98599L5.026 4.93699L13.026 2.26999ZM13 4.38799L6 6.72099V19H13V4.38799ZM15 11.221V19H18V11.82L15 11.221Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.3065ab760f2fdea964b777a27f1409ff.svg";
export { ForwardRef as ReactComponent };